
// Import external Libs
import 'bootstrap';
import 'lazysizes';

//Import Navi and boilerplates
import '../../components/navi-bootstrap-offcanvas/navi-bootstrap-offcanvas';
import '../../components/navi-desktop-bootstrap/navi-desktop-bootstrap';
import { NavSwitcherSections } from '../../components/NavSwitcherSections/NavSwitcherSections';
import { NavScrollToggle } from "../../components/NaviScrollToggle/NaviScrollToggle";


import '../../components/font-service/font-service';
import '../../components/smooth-scrolling/smooth-scrolling.js';

import '../../components/EmergingImages/EmergingImages';
import '../../components/UnbluringImages/UnbluringImages';

import '../../components/fixed-bg/fixed-bg';
import '../../components/bootstrap-form/bootstrap-form.js';

import { initSimplePreloader, checkAndRemoveSimplePreloader } from '../../components/preloader/preloader';

// Import own libs
import '../../components/Raiser/Raiser';

// Import page specials
// import '../../components/hexagon-starter/hexagon-starter';
// import '../../components/hexagon-pre-footer/hexagon-pre-footer';
// import '../../components/in-brackets/in-brackets';
// import '../../components/accordion/accordion';
// import '../../components/bg-svg-wrp/bg-svg-wrp';


// Page SCSS last Import
import './scss/page-meta.scss';

// Javascript Starts here 
initSimplePreloader({
  windowLoad: false,
});

// Mobile Background Nav Toggle
initSimplePreloader({
  windowLoad: false,
  // iwaraReady: false
});

window.addEventListener('load', () => {
  checkAndRemoveSimplePreloader('windowLoad');
})

const navSwitcherSections = new NavSwitcherSections({ startClass: 'nav-darkBG-white' })